"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const painPoints = [{
  title: "Essential Cookies",
  description: "Strictly necessary for the website to function. They enable basic features like page navigation and access to secure areas of the platform."
}, {
  title: "Performance Cookies",
  description: "Used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for visitors."
}, {
  title: "Functional Cookies",
  description: "Allow our website to remember choices you make (such as your user name or language) and provide enhanced, more personal features."
}, {
  title: "Targeting Cookies",
  description: "Set through our site by advertising partners to build a profile of your interests and show you relevant adverts on other sites."
}, {
  title: "Social Media Cookies",
  description: "Enable you to share our content with your friends and networks. They can track your browser across other sites and build a profile of your interests."
}, {
  title: "Analytics Cookies",
  description: "Help us collect information about how visitors use our website, including the number of visitors and the pages they visit most frequently."
}];
export default function TheReality() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="150691" id="types-of-cookies-used" ref={sectionRef} className="bg-background py-24 md:py-32 overflow-hidden relative">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <span className="font-mono text-primary tracking-[0.1em] uppercase mb-6 block text-sm font-semibold">
              Cookie Policy
            </span>
            <h2 className="font-serif text-foreground text-4xl md:text-[3rem] leading-[1.1] font-bold mb-6">
              How we use cookies to improve your experience.
            </h2>
            <p className="font-sans text-muted-foreground text-lg leading-relaxed max-w-md">
              We use various types of cookies to ensure our platform remains secure, functional, and tailored to your specific logistical needs.
            </p>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {painPoints.map((point, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: `${i * 100}ms`
            }}>
                  <Card className="h-full bg-card/40 backdrop-blur-[12px] border-[1px] border-secondary/30 rounded-none shadow-none transition-all duration-200 hover:bg-[hsl(220,45%,12%)] hover:border-secondary/60 !gap-4 !py-6">
                    <CardHeader className="pb-0 px-6">
                      <CardTitle className="font-mono text-primary text-xl md:text-[1.25rem] font-bold leading-tight uppercase">
                        {point.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="px-6 pt-2">
                      <p className="font-sans text-muted-foreground text-[15px] leading-relaxed">
                        {point.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}